<template>
	<div class="main-contents">
		<div class="tit">
			이력서 검토
			<img src="/images/admin/list_shortcut.png" alt="목록가기" @click="$router.push({name: 'MEM910M01', replace: true })"/>
		</div>
		<div class="member-name" v-if="data.mberNm"><span>{{data.mberNm}}</span> 회원님<img src="/images/admin/alert_guide.png" alt="문구"/></div>
		<div class="contents-body">
			<tec-resume ref="tecResume" :tecMberSeq="this.tecMberSeq" :admMdf="true"/>

			<!-- 하단 버튼 -->
			<div class="select_btn" v-if="isMounted">
				<div class="btn_01" @click="cancel()" v-if="auth('관리자')">취소</div>
				<div class="btn_02" @click="save()" v-if="auth('관리자') && !auth('등록')" style="background-color: #FF681D;">수정하기</div>
				<!-- <div class="btn_02" @click="saveTemp()" v-if="auth('관리자') &&  auth('등록')" style="background-color: #fff;color:#414042;border:1px solid #58595B;">임시저장</div> -->
				<div class="btn_03" @click="save()" v-if="auth('관리자') &&  auth('등록')" style="background-color: #17A1FF;">등록완료</div>
			</div>

			<!-- 기술회원 메모 -->
			<tec-memo :tecMberSeq="tecMberSeq"/>
		</div>
	</div><!-- //main-contents -->
</template>
<script>
import tecMemo from "@/components/highpro/adm/TecMemo.vue";
import tecResume from "@/components/highpro/TecResume.vue";


export default {
	components: { tecMemo, tecResume },
	data() {
		return {
			tecMberSeq: this.$route.params.tecMberSeq,
            isMounted: false,
			// pointList: [],
			// checkAll: false,
        };
    },
    mounted(){
        this.isMounted = true;
    },
	methods: {
		cancel(){
            this.$router.go(-1);
        },
		validSave(){
            //console.log('PRF101M01', 'validSave', this.$refs.tecResume.data);
            var data = this.$refs.tecResume.data;
            var check = false;

            //고등학교 이상 졸업
            for(var i1 in data.schoolList){
                if(data.schoolList[i1].schoolStatusCd == '00'){
                    check = true;
                    break;
                }
            }
            if(!check){
                alert('학력사항 고등학교 이상 졸업 사항은 필수사항입니다.');
                this.$refs.tecResume.$refs.school.focusOn();
                return false;
            }

            //프로젝트 경력이 재직경력에 포함되는지 체크
            // for(var i2 in data.projectList){
            //     var project = data.projectList[i2];
            //     if(project.joinStartYyyymm && project.joinEndYyyymm){
            //         check = false;
            //         for(var j2 in data.careerList){
            //             var career = data.careerList[j2];
            //             if(career.workStartYyyymm <= project.joinStartYyyymm && project.joinEndYyyymm <= career.workEndYyyymm){
            //                 if(project.workPatCd != career.workPatCd){
            //                     alert('입력하신 프로젝트 기간에 근무한 회사와 근무형태가 다릅니다.');
            //                     this.$refs.tecResume.$refs.project.focusOn(i2);
            //                     return false;
            //                 }
            //                 check = true;
            //                 break;
            //             }
            //         }
            //         if(!check){
            //             alert('입력하신 프로젝트 기간에 근무한 회사재직경력이 없습니다.\n해당 프로젝트 기간에 근무한 회사 재직경력을 확인해 주세요.');
            //             console.log();
            //             this.$refs.project.focusOn(i2);
            //             return false;
            //         }
            //     }
            // }

            return true;
        },
        save(){
            //console.log('PRF101M01', 'save', this.$refs.tecResume.data);
            var data = this.$refs.tecResume.data;
            if(!this.validSave()){
                return;
            }
            
            //첨부파일 처리
            var files = [];
            // if(data.profileImg){
            //     //이미지
            //     data.profile = data.profileImg.name;
            //     files.push(data.profileImg);
            // }
            for(var i in data.attaFileRelList){
                var attaFile = data.attaFileRelList[i];
                if(attaFile.file instanceof File){
                    //첨부파일이 있을 경우 첨부파일을 추가한다.
                    attaFile.uploadIndex = files.length;
                    attaFile.orgFileNm   = attaFile.file.name;
                    files.push(attaFile.file);
                } else if(!attaFile.attaFileSeq && attaFile.resumeAttaFileDataNm) {
                    //추가한 파일목록 중에 증빙서류 구분은 있는데 첨부파일이 포함되지 않은 경우.
                    //delete data.attaFileRelList[i];
                    alert('첨부파일을 추가해주세요.');
                    this.$refs.attaFile.focusOn(i);
                    return;
                }
            }

			data.tecMberSeq = data.mberSeq;

            this.$.fileUpload('IMG_PDF_DOC', files, '/api/mem/prf/saveResume', data )
                .then(() => {
                    //console.log('PRF101M01', 'saveResume', res.data);
                    // if('Y' == data.regYn){
                    //     this.$.popup('/tec/prf/PRF101P02')
                    //         .then(res => {
                    //             if(res){
                    //                 this.moveNCS(true);
                    //             } else {
                    //                 this.$refs.tecResume.search();
                    //             }
                    //         })
                    // } else {
                    //     alert('저장이 완료되었습니다.');
                    //     this.$refs.tecResume.search();
                    // }

					alert('저장이 완료되었습니다.');
					var params = {
						tecMberSeq : data.mberSeq
					}
					this.$router.push({name: 'MEM910M02', params });

                })
                .catch(e => {
                    console.error(e, data);
                    alert("저장 중 에러가 발생했습니다.");
                });
        },

		auth(checks){
            //console.log('auth', this.$refs)
            return this.$refs.tecResume.auth(checks);
        }
	},
	computed: {
		data(){
			//console.log('MEM910M02', 'data', this.$refs.tecResume);
			if(this.isMounted && this.$refs.tecResume && this.$refs.tecResume.data){
				return this.$refs.tecResume.data;
			} else {
				return {};
			}
		}
	}
};
</script>
